import { render, staticRenderFns } from "./ProductGridItem.vue?vue&type=template&id=7cdb39d4&scoped=true&"
import script from "./ProductGridItem.vue?vue&type=script&lang=js&"
export * from "./ProductGridItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductGridItem.vue?vue&type=style&index=0&id=7cdb39d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdb39d4",
  null
  
)

export default component.exports